import { Icon } from '@coop/components';
import { EcoLeafIcon } from '@coop/icons';
import classnames from 'classnames';

interface RecipeClimateImpactProps {
    climateImpactKg: number | null;
    climateImpactUrl?: string;
}

const RecipeClimateImpact = (props: React.PropsWithChildren<RecipeClimateImpactProps>) => {
    const getClimateTitle = () => {
        if (!props.climateImpactKg) return '';
        if (props.climateImpactKg < 0.7) return 'Klimatmärkning: 3 löv';
        if (props.climateImpactKg < 1.7) return 'Klimatmärkning: 2 löv';
        if (props.climateImpactKg < 2.5) return 'Klimatmärkning: 1 löv';
    };

    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {!!props.climateImpactKg && props.climateImpactKg < 2.5 && (
                <div className="u-textSmall u-textWeightBold u-flex u-flexAlignCenter u-flexWrap u-flexGap8">
                    <Icon
                        icon={EcoLeafIcon}
                        className={classnames(
                            props.climateImpactKg < 2.5 ? 'u-fillLime' : 'u-fillGrayLight2',
                        )}
                        width={28}
                        height={28}
                        aria-label="Ett löv: 1,7 – 2,5 kg koldioxidekvivalenter per portion"
                        role="img"
                    />
                    <Icon
                        icon={EcoLeafIcon}
                        className={classnames(
                            props.climateImpactKg < 1.7 ? 'u-fillLime' : 'u-fillGrayLight2',
                        )}
                        width={28}
                        height={28}
                        title="Två löv: 0,7 – 1,6 kg CO2 koldioxidekvivalenter per portion"
                        role="img"
                    />
                    <Icon
                        icon={EcoLeafIcon}
                        className={classnames(
                            'u-marginRxxsm',
                            props.climateImpactKg < 0.7 ? 'u-fillLime' : 'u-fillGrayLight2',
                        )}
                        width={28}
                        height={28}
                        aria-label="Tre löv: 0 – 0,6 kg koldioxidekvivalenter per portion"
                        role="img"
                    />

                    {!props.climateImpactUrl ? (
                        <span
                            aria-label={`
                            ${Intl.NumberFormat('sv').format(props.climateImpactKg)} koldioxidekvivalenter per portion. ${getClimateTitle()}
                        `}
                        >
                            {Intl.NumberFormat('sv').format(props.climateImpactKg)} kg CO
                            <sub>2</sub> ekv / portion
                        </span>
                    ) : (
                        <a
                            className="Link Link--underline u-textUnderlinePositionUnder"
                            href={props.climateImpactUrl}
                            title="Se hur klimatpåverkan beräknas"
                            aria-label={`
                                ${Intl.NumberFormat('sv').format(props.climateImpactKg)} koldioxidekvivalenter per portion. ${getClimateTitle()}
                            `}
                        >
                            {Intl.NumberFormat('sv').format(props.climateImpactKg)} kg CO
                            <sub>2</sub> ekv / portion
                        </a>
                    )}
                </div>
            )}
        </>
    );
};

export default RecipeClimateImpact;
